// Resolves a layout-manifest widget key to its concrete React component.
// Adding a new home widget = create the component + register it here +
// add the key to /app/backend/seeds/registries/home_widgets.json.
import KpiHeroWidget from "./KpiHeroWidget";
import QuickActionsWidget from "./QuickActionsWidget";
import PinnedDashboardsWidget from "./PinnedDashboardsWidget";
import RecentActivityWidget from "./RecentActivityWidget";
import WorkspaceFeedWidget from "./WorkspaceFeedWidget";
import RecentlySharedWidget from "./RecentlySharedWidget";
import AiUsageWidget from "./AiUsageWidget";
import DatasetsAttentionWidget from "./DatasetsAttentionWidget";
import WhatsNewWidget from "./WhatsNewWidget";
import TenantHealthWidget from "./TenantHealthWidget";
import ContinueWidget from "./ContinueWidget";
import BillingHealthWidget from "./BillingHealthWidget";
import PrebuiltsWidget from "./PrebuiltsWidget";
// iter-121.116 — SA Platform Cockpit widgets
import SaActionLane from "./cockpit/SaActionLane";
import SaInfoTabs from "./cockpit/SaInfoTabs";
// iter-121.117 — OA Cockpit widgets
import OaActionLane from "./cockpit/OaActionLane";
import OaInfoTabs from "./cockpit/OaInfoTabs";
// iter-121.118 — EA Cockpit widgets
import EaActionLane from "./cockpit/EaActionLane";
import EaInfoTabs from "./cockpit/EaInfoTabs";
import EaRecentActivity from "./cockpit/EaRecentActivity";
// iter-121.126 — EV Cockpit (Entity Viewer)
import EvCockpit from "./cockpit/EvCockpit";

// Each entry: { component, defaultH (rows in 12-col grid layout) }
export const HOME_WIDGET_REGISTRY = {
    kpi_hero:           { component: KpiHeroWidget,           defaultH: 3, label: "Hero KPIs" },
    continue_where_left_off: { component: ContinueWidget,     defaultH: 3, label: "Continue where you left off" },
    quick_actions:      { component: QuickActionsWidget,      defaultH: 3, label: "Quick actions" },
    pinned_dashboards:  { component: PinnedDashboardsWidget,  defaultH: 6, label: "Pinned dashboards" },
    recent_activity:    { component: RecentActivityWidget,    defaultH: 6, label: "Recent activity" },
    workspace_feed:     { component: WorkspaceFeedWidget,     defaultH: 6, label: "Activity in your workspaces" },
    recently_shared:    { component: RecentlySharedWidget,    defaultH: 5, label: "Recently shared with you" },
    ai_usage_chip:      { component: AiUsageWidget,           defaultH: 4, label: "AI usage" },
    datasets_attention: { component: DatasetsAttentionWidget, defaultH: 6, label: "Needs attention" },
    whats_new:          { component: WhatsNewWidget,          defaultH: 6, label: "What's new" },
    tenant_health:      { component: TenantHealthWidget,      defaultH: 6, label: "Entity health" },
    billing_health:     { component: BillingHealthWidget,     defaultH: 5, label: "Billing health" },
    prebuilts:          { component: PrebuiltsWidget,         defaultH: 6, label: "Prebuilt templates" },
    // iter-121.116 — SA Platform Cockpit
    sa_action_lane:     { component: SaActionLane,            defaultH: 6, label: "For Your Action" },
    sa_info_tabs:       { component: SaInfoTabs,              defaultH: 14, label: "For Your Information" },
    // iter-121.117 — OA Cockpit
    oa_action_lane:     { component: OaActionLane,            defaultH: 8, label: "For Your Action" },
    oa_info_tabs:       { component: OaInfoTabs,              defaultH: 16, label: "For Your Information" },
    // iter-121.118 — EA Cockpit
    ea_action_lane:     { component: EaActionLane,            defaultH: 8, label: "For Your Action" },
    ea_info_tabs:       { component: EaInfoTabs,              defaultH: 16, label: "For Your Information" },
    ea_recent_activity: { component: EaRecentActivity,        defaultH: 9, label: "Recent activity" },
    // iter-121.126 — EV Cockpit (single consolidated widget)
    ev_cockpit:         { component: EvCockpit,               defaultH: 18, label: "EV Cockpit" },
};

export function HomeWidget({ widgetKey, onEmpty }) {
    const entry = HOME_WIDGET_REGISTRY[widgetKey];
    if (!entry) {
        return (
            <div className="border border-dashed border-border rounded-sm p-4 text-xs text-muted-foreground"
                 data-testid={`home-widget-unknown-${widgetKey}`}>
                Unknown widget: <code>{widgetKey}</code>
            </div>
        );
    }
    const C = entry.component;
    return <C onEmpty={onEmpty} />;
}
